export enum ValidationsGOF {
  CoursModifiable = 'cours_modifiable',
}
